// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__bj+qd","summary":"CartItem_summary__zaijZ","price":"CartItem_price__ag6yt","amount":"CartItem_amount__gMC3W","actions":"CartItem_actions__QgAwc"};